import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const ActionBar = styled.div`
  width: 100%;
  background: white;
  padding-bottom: 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media(max-width: ${measures.mobileThreshold}px) {
    background: ${colors.waterBlue};
    padding: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 101;
  }
`

export const MailsWrapper = styled.div`
  height: calc(100% - 100px);

  background: white;
  border-radius: 4px;
  padding: 24px 14px 34px 34px;
`

export const DomiciliationsList = styled.div`
  height: 100%;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: ${measures.mobileThreshold}px) {
    padding: 0;
  }
`

export const DomiciliationsListScrollPanel = styled.div`
  padding-right: 10px;
  overflow-y: auto;
  flex: 1;

  @media (max-width: ${measures.mobileThreshold}px) {
    padding-right: 0;
  }
`

export const DomiciliationMails = styled.div`
  margin-bottom: 33px;
`

interface DomiciliationMailsHeaderProps {
  selected: boolean
}

export const DomiciliationMailsHeader = styled.div<DomiciliationMailsHeaderProps>`
  line-height: 19px;
  border-bottom: 1px solid ${colors.lightGrey};
  padding: 6px 0;
  display: flex;
  align-items: center;

  @media (max-width: ${measures.mobileThreshold}px) {
    border-bottom: none;
    padding: 20px;
    margin-bottom: 16px;

    ${(props) => props.selected && `
      background-color: ${colors.footerColor};
      border-bottom: 1px solid ${colors.lighterGrey};
    `};
  }
`

export const DomiciliationName = styled.span`
  font-weight: bold;
  margin-left: 20px;
  color: ${colors.waterBlue};
  a {
    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const DomiciliationSociety = styled.span`
  margin-left: 15px;

  @media (max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const DomiciliationForwardingAddress = styled.span`
  font-weight: 400;
  margin-left: 15px;

  @media (max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const DomiciliationInfosMobile = styled.div`
  margin-left: 30px;
  display: none;
  flex-direction: column;

  @media (max-width: ${measures.mobileThreshold}px) {
    display: flex;
  }

  & > ${DomiciliationName} {
    margin: 0;
    display: inline;
  }

  & > ${DomiciliationSociety} {
    width: 100%;
    margin: 0 0 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
  }

  & > ${DomiciliationForwardingAddress} {
    margin: 0;
    display: inline;
  }
`

export const MobileMailsNumber = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-right: 7px;
  display: none;
`

export const DomiciliationMailsTotal = styled.span`
  color: ${colors.darkGrey};
  font-weight: 600;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;

  .mails-count {
    color: ${colors.waterBlue};
    margin-right: 4px;
  }

  & > svg {
    margin-right: 9px;
  }
 .mobile-display {
    display: none;
  }

  @media (max-width: ${measures.mobileThreshold}px) {
    & > span {
      display: none;
    }

    & > ${MobileMailsNumber} {
      display: inline;
    }
  }
  @media (max-width: 825px) {
    & > svg {
      display: none;
    }
    .mobile-display {
      display: inline;
      margin-right: 10px;
    }
    .mobile-hide {
      display: none;
    }
  }
`

export const DomiciliationMailsContent = styled.div`
  padding: 0 37px;

  @media(max-width: ${measures.mobileThreshold}px) {
    padding: 0 16px;
  }
`

export const EmptyListWrapper = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  & > span {
    margin-top: 15px;
    font-size: 15px;
  }
`
